export enum MemberTypeId {
    DISTRIBUTOR = 5,
    RETAILCUSTOMER = 6,
    GUESTCUSTOMER = 93,
    PREFERREDCUSTOMER = 99
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/member-type-id.enum.ts